import { AutogenLayoutSettlement401kHistory } from "./autogen/AutogenLayoutSettlement401kHistory";
import { DataSourceMode, DataSourceModeChangeEvent } from "@mcleod/components";

export class Settlement401kHistory extends AutogenLayoutSettlement401kHistory {
    onLoad(): void | Promise<void> {
    }

    sourceDrs401kHistAfterModeChange(event: DataSourceModeChangeEvent) {
        this.dataheaderSettlement401kHistory.showExecute = event.newMode === DataSourceMode.SEARCH;
    }
}
